import { Container, Box, Typography } from "@mui/material";
const CentralizedLayout: React.FC<any> = ({ children }) => {
    return (
        <div>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.0)",
                    zIndex: -999,
                    float: "left",
                }}
            >
                <video
                    id="startvideo"
                    loop
                    no-controls={"true"}
                    muted
                    autoPlay={true}
                    playsInline={true}
                    src="/assets/videos/WelcomeBG.mp4"
                    style={{ objectFit: "fill" }}
                ></video>
            </div>
            <Container
                disableGutters={true}
                maxWidth={false}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                {children}
            </Container>
        </div>
    );
};

export default CentralizedLayout;
